<template>
  <v-menu
    offset-y
    :nudge-left="isLogin ? 200 : 0"
    nudge-bottom="10"
    max-height="43rem"
    light
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
        x-large
        dark
        class="mr-6 p-relative"
        @click="clickNotification"
      >
        <v-scale-transition origin="center center">
          <div v-show="notification" class="notify-dot p-absolute"></div>
        </v-scale-transition>
        <img
          src="/assets/ic/header/ic_header_notification_white.svg"
          alt="notification icon"
        />
      </v-btn>
    </template>
    <v-list subheader two-line>
      <v-list-item v-if="!isLogin">
        <v-list-item-title>
          {{ $t("nav.notLogin") }}
        </v-list-item-title>
      </v-list-item>
      <div v-else>
        <v-subheader>{{ $t("notification.orderStatus") }}</v-subheader>
        <div
          v-for="(order, idx) in data.orders"
          :key="'orderStatus' + idx"
          class="mb-1"
        >
          <v-stepper alt-labels v-model="order.orderStatus">
            <span class="pl-4">
              {{ $t("profile.order.orderId") }}: {{ order.orderIndex }}
            </span>
            <v-stepper-header>
              <v-stepper-step
                v-if="order.orderStatus < 6"
                :key="`orderStatus${idx}_${order.orderStatus - 1}`"
                :step="order.orderStatus - 1"
              >
                {{ orderStatus[order.orderStatus - 1] }}
              </v-stepper-step>
              <v-divider v-if="order.orderStatus < 6"></v-divider>
              <v-stepper-step
                class="mx-auto"
                color="orange"
                :key="`orderStatus${idx}_${order.orderStatus}`"
                :step="order.orderStatus"
              >
                {{ orderStatus[order.orderStatus] }}
              </v-stepper-step>
              <v-divider v-if="order.orderStatus < 6"></v-divider>
              <v-stepper-step
                v-if="order.orderStatus < 6"
                :key="`orderStatus${idx}_${order.orderStatus + 1}`"
                :step="order.orderStatus + 1"
              >
                {{ orderStatus[order.orderStatus + 1] }}
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </div>
        <v-divider></v-divider>
        <div v-if="message">
          <v-subheader>
            {{ $t("notification.newMessage") }}
          </v-subheader>
          <v-list-item class="px-7" @click="openMessage">
            <v-list-item-avatar>
              <div>
                <v-img
                  contain
                  src="/assets/ic/contact/chatbox_head.svg"
                  alt="admin_avatar"
                ></v-img>
              </div>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ message.message }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ dateFormat(message.createTime) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </div>
        <v-subheader>{{ $t("notification.newTags") }}</v-subheader>
        <v-list-item
          class="px-7"
          v-for="(tag, idx) in data.tags"
          :key="'newTag' + idx"
        >
          <v-list-item-avatar>
            <v-img
              v-if="tag.imgPath"
              :src="getStaticFileURL(tag.imgPath)"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ tag.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ dateFormat(tag.createTime) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("user", ["isLogin", "notification"]),
    ...mapState("cart", ["cartLoading", "cart"]),
    orderStatus() {
      return [
        this.$t("profile.order.orderCreated"),
        this.$t("profile.order.unpaid2"),
        this.$t("profile.order.waitingForPayment"),
        this.$t("profile.order.orderProcessing"),
        this.$t("profile.order.transporting"),
        this.$t("profile.order.orderCompleted"),
        this.$t("profile.order.orderReturn"),
        this.$t("profile.order.cancelOrder")
      ];
    }
  },
  data() {
    return {
      data: {
        messages: [],
        orders: [],
        tags: []
      },
      message: null,
      init: false
    };
  },
  methods: {
    ...mapMutations("user", ["setUserNotification"]),
    ...mapActions("contact", ["openContact"]),
    openMessage() {
      this.openContact();
    },
    async clickNotification() {
      this.$forceUpdate();
      if (!this.isLogin || (this.init && !this.notification)) return;
      const res = await this.$http.get("members/notification");
      this.data = res.data;
      if (res.data.messages.length > 0) this.message = this.data.messages[0];
      this.init = true;
      this.$forceUpdate();
      this.setUserNotification(false);
    }
  },
  watch: {
    isLogin() {
      this.data.messages.length = 0;
      this.data.orders.length = 0;
      this.data.tags.length = 0;
      this.message = null;
      this.init = false;
    }
  }
};
</script>

<style lang="sass" scoped>
.notify-dot
  background: #FF6868
  width: 13px
  height: 13px
  right: 8px
  top: 8px
  border-radius: 100%
  border: 1px solid white

.v-stepper, .v-stepper__header
  box-shadow: none !important
::v-deep .v-stepper__label
  text-shadow: none !important
  text-align: center !important
::v-deep .v-stepper__step--active
  .v-stepper__label
    color: #ff9800 !important
</style>
